import { render, staticRenderFns } from "./PromptsAdmin.vue?vue&type=template&id=62aea4f6&scoped=true&"
import script from "./PromptsAdmin.vue?vue&type=script&lang=ts&"
export * from "./PromptsAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aea4f6",
  null
  
)

export default component.exports